import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  clearCacheLoading: false,
  clearCacheSuccess: null,
  clearCacheError: '',
}

export const clearCacheSlice = createSlice({
  name: 'clearCache',
  initialState,
  reducers: {
    setClearCacheLoading: (state, action) => {
      state.clearCacheLoading = true;
      state.clearCacheSuccess = null;
      state.clearCacheError = '';
    },
    setClearCacheSuccess: (state, action) => {
      state.clearCacheLoading = false;
      state.clearCacheSuccess = action.payload;
      state.clearCacheError = '';
    },
    setClearCacheError: (state, action) => {
      state.clearCacheLoading = false;
      state.clearCacheSuccess = null;
      state.clearCacheError = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setClearCacheLoading, setClearCacheSuccess, setClearCacheError } = clearCacheSlice.actions

export default clearCacheSlice.reducer;